// extracted by mini-css-extract-plugin
export default {"input":"styles_input__q5Dlb","color":"styles_color__A5yTc","value":"styles_value__Qm0Wu"};